<template>
    <div class="popup_wrpr_inner">
        <div class="popup">
            <div class="popup_header">
                <h3>Are you sure you'd like to delete this product?</h3>
                <a @click="closePopup" class="close_popup_btn">
                    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
                </a>
            </div>
            <div class="popup_btn_wrpr mt_0 active">
              <v-button @click="deleteProduct" :loading="loading" red border label="Delete"></v-button>
              <a @click="closePopup" class="btn">Cancel</a>
            </div>
        </div>
    </div>
</template>

<script>
import API from "@/api"
import VButton from "@/components/base/v-button";

export default {
    name: "ProductDeletePopup",
  components: {VButton},
  props:['productId', 'isFplus', 'funnelId', 'stepId'],
    mixins: [API],
    data() {
        return {
          loading: false,
            deleteBtnState: false,
            checkboxModel1: false,
            checkboxModel2: false,
            checkboxModel3: false,
            progressNumber: 0
        }
    },
    methods: {
        closePopup() {
            this.$store.commit("closeProductDeletePopup");
            this.$emit("cancel")
        },
        async deleteProduct() {
          try {
            this.loading = true;
            let {productId} = this.$route.params;

            if (!this.isFplus) {
              if (productId) this.$router.push({path: `/funnel/${this.funnelId}/steps/${this.stepId}`})
              else productId = this.productId;

              await this.api.steps.deleteProduct(productId);
            } else {
              if (productId) this.$router.push({path: `/wfunnel/${this.funnelId}/steps/${this.stepId}`})
              else productId = this.productId;

              await this.api.wsteps.deleteProduct(this.funnelId, this.stepId, this.productId);
            }
            this.$store.dispatch('REMOVE_PRODUCT', this.productId);
            this.$store.commit("closeProductDeletePopup");
            this.$emit("done");
          } catch (e) {
            console.error("ERROR", e);
          } finally {
            this.loading = false;
          }
        },
    },
}
</script>

<style>
    .brdr_box_w_checkbox h3 b {
        margin-right: 3px;
    }
</style>
